import React, {useCallback, useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import QueryTable from "../../../../../../ui/QueryTable";
import useQuery from "../../../../../../ui/QueryTable/useQuery";
import ProgramInfoDrawer from "../../components/ProgramInfoDrawer";
import SimpleMenu from "../../../../../../ui/SimpleMenu";
import AddButton from "../../../../../../ui/AddButton";
import AddProgramModal from "../../components/AddProgramModal";
import AddPlanModal from "../../../../../../Study/Plan/components/AddPlanModal";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "/work/app/manage/resources/programs"
  },
  {
    label: "Мои программы",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const MyOpProgramList = () => {
  const [focusedProgram, setFocusedProgram] = React.useState(-1);
  const [addProgramOpen, setAddProgramOpen] = useState(false);
  const {root} = useStyles();
  const query = useQuery(1);

  useEffect(() => {
    query.load();
  }, []);

  const TableRowClick = (e) => {
    const focusedProgram = e ? e.key : -1;
    setFocusedProgram(focusedProgram);
  };

  const showAddModal = useCallback(() => {
    setAddProgramOpen(!addProgramOpen)
  }, [addProgramOpen]);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <AddProgramModal open={addProgramOpen}
                       handleClose={showAddModal}/>
      <div className={root}>
        <QueryTable
          focusedId={focusedProgram}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={showAddModal}/>}
          {...query} />
        <ProgramInfoDrawer
          handleDrawerClose={() => TableRowClick(null)}
          programId={focusedProgram}
          open={focusedProgram !== -1}
        />
      </div>
    </div>
  );
};

export default MyOpProgramList;
